import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import ServiceProviderCard from "../ServiceProviderCard";
import HowItWorks from "../SubServicesPage/HowItWorks";
import LoadingAnimation from "../../Animations/LoadingAnimation";
import {
  fonts,
  headingFonts,
  notFoundBox,
  semiBoldFonts,
} from "../../../Styles/Styles";

const SubServicesProviders = () => {
  const { serviceId, subServiceId } = useParams();
  const [providers, setProviders] = useState(null);
  const [subService, setSubService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch subservice details from API
    const fetchProviders = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/services/SubServicesProviders/${serviceId}/${subServiceId}`
        );
        const data = await response.json();
        setProviders(data.serviceProviders);
        setSubService(data.subService);
        console.log(data);
      } catch (error) {
        console.error("Failed to fetch subservice details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, [serviceId, subServiceId]);

  if (loading) {
    return <LoadingAnimation />;
  }

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "50vh", // Fullscreen height
          backgroundImage: `url(${subService.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "white", // Text color on overlay
        }}
      >
        {/* Background Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent overlay
          }}
        />

        {/* Text Content */}
        <Box sx={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{
              ...semiBoldFonts,
              letterSpacing: 2,
              textTransform: "uppercase",
            }}
          >
            {subService.name}
          </Typography>
          <Typography variant="h6" color="white" mt={1} sx={{ ...fonts }}>
            Browse through our list of {subService.name} service providers to
            find the perfect service for your needs.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ p: 2, width: "95%", margin: "0 auto" }}>
        <Box sx={{ mt: 2, display: "flex", flexDirection: "row", gap: 2 }}>
          <Box sx={{ flex: 2, mt: 2 }}>
            {providers.length > 0 ? (
              <>
                {providers.map((provider, index) => (
                  <ServiceProviderCard key={index} provider={provider} />
                ))}
              </>
            ) : (
              <Box mt={3} sx={{ ...notFoundBox }}>
                <SearchOffOutlinedIcon
                  sx={{
                    color: "var(--primary-color)",
                    fontSize: 50,
                    opacity: 0.5,
                    marginBottom: 1,
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    color: "var(--primary-color)",
                    ...headingFonts,
                  }}
                >
                  Oops! Service Providers Not Found
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.7, ...fonts }}>
                  We couldn't find any service providers at the moment. Please
                  try again later.
                </Typography>
              </Box>
            )}
          </Box>
          <HowItWorks />
        </Box>
      </Box>
    </Box>
  );
};

export default SubServicesProviders;
